import { default as DragRotate } from 'ol/interaction/DragRotate';
import { default as RBaseInteraction } from './RBaseInteraction';
/** Rotation by clicking and dragging */
class RDragRotate extends RBaseInteraction {
    createOL(props) {
        this.classProps = RDragRotate.classProps;
        return new DragRotate(Object.keys(props)
            .filter((p) => this.classProps.includes(p))
            .reduce((ac, p) => (Object.assign(Object.assign({}, ac), { [p]: props[p] })), {}));
    }
}
RDragRotate.classProps = ['condition', 'duration'];
export default RDragRotate;
//# sourceMappingURL=RDragRotate.js.map